export { serverMessage, usable } from "../finance/financeCopy";

export const REVIEWS_COPY = {
  submitFailed: "Could not save your review. Please try again.",
  deleteFailed: "Could not remove this review. Please try again.",
  deleted: { title: "Review Removed", message: "Your rating and review have been deleted." },
  created: { title: "Review Posted", message: "Thanks for sharing your experience." },
  updated: { title: "Review Updated", message: "Your review has been updated." },
  deleteConfirm: {
    title: "Delete This Review?",
    message:
      "This removes your rating and review for this supplier or product. You can always leave a new one.",
  },
  noWrittenReview: "No written review.",
};

export const REVIEWS_EMPTY_STATES = {
  noReviews: {
    title: "No Reviews",
    body: "You haven't left any feedback yet. Once an order is delivered you can rate the supplier.",
  },
  listError: {
    title: "Could Not Load Your Reviews",
    body: "Something went wrong while reading your reviews.",
  },
};
